module.exports = function UpdateSourceState(state) {
    this.state = state;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-state.js
// module id = 500
// module chunks = 1